import { Loader2, Check, AlertCircle } from 'lucide-react';
import type { ToolStatus } from '../../hooks/useAgentSession';

interface ToolStatusCardProps {
  tool: ToolStatus;
}

export default function ToolStatusCard({ tool }: ToolStatusCardProps) {
  return (
    <div className="flex items-center gap-2 px-4 py-2 mx-4 my-1 bg-gray-50 rounded-lg border border-gray-100 animate-fadeIn">
      {tool.status === 'running' && (
        <Loader2 className="w-4 h-4 text-blue-500 animate-spin shrink-0" />
      )}
      {tool.status === 'complete' && (
        <Check className="w-4 h-4 text-green-500 shrink-0" />
      )}
      {tool.status === 'error' && (
        <AlertCircle className="w-4 h-4 text-red-500 shrink-0" />
      )}
      <span className="text-sm text-gray-600">
        {tool.status === 'running' ? tool.description : tool.summary || tool.description}
      </span>
    </div>
  );
}
